import { render } from "./ArtifactView.vue?vue&type=template&id=5f1b3b68"
import script from "./ArtifactView.vue?vue&type=script&lang=js"
export * from "./ArtifactView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__